import { DEFAULT_STRATEGY_DURATION } from "@bridgesplit/abf-react";

import { WindForm, ManualLoopMode } from "./types";

export const DEFAULT_WIND_FORM: WindForm = {
    inputAmount: undefined,
    multiplier: undefined,
    multiplierWithoutDebounce: undefined,
    strategyDuration: DEFAULT_STRATEGY_DURATION,
    percentSlippageDecimals: undefined,
    inputToken: undefined,
    collateralAmount: undefined,
    principalAmount: undefined,
    ltvMultiplier: 0,
    manualMode: ManualLoopMode.InputCollateral
};
